import * as ReactCompat from "@reckona/mreact-compat";

/** Default React-compatible namespace export for @reckona/mreact. */
export default ReactCompat;
